if (!customElements.get("faqs-columns")) {
  class FaqsColumns extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.#syncVars();

      // Observe style attribute changes for real-time updates in the theme editor
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "style"
          ) {
            this.#syncVars();
          }
        });
      });

      this.observer.observe(this, {
        attributes: true,
        attributeFilter: ["style"],
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #syncVars() {
      const parent = this.parentElement;
      if (!parent) return;

      const styles = this.getAttribute("style");
      if (!styles) return;

      // Extract all CSS variables from the style attribute
      const varRegex = /(--[\w-]+)\s*:\s*([^;]+)/g;
      let match;

      while ((match = varRegex.exec(styles)) !== null) {
        const [_, prop, value] = match;
        parent.style.setProperty(prop, value.trim());
      }
    }
  }

  customElements.define("faqs-columns", FaqsColumns);
}
